import { ErrorComponent } from "components/common";
import { Label, LabelForm, } from "components/label";
import React from "react";
import { withErrorBoundary } from "react-error-boundary";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { Error } from "components/error";

const Textarea = ({
	label,
	placholder,
	error = {},
	className = "",
	control,
	name,
	...rest
}) => {
	const { field } = useController({
		control,
		name,
		defaultValue: "",
	});
	return (
		<div className="form-group pms-input-textarea">
			<LabelForm htmlFor={name}>{label}</LabelForm>
			<textarea
				className="form-control k-input"
				rows="4"
				cols="20"
				id={name}
				name={name}
				{...rest}
				{...field}></textarea>
			{error && <Error>{error[name]?.message}</Error>}
		</div>
	);
};

Textarea.propTypes = {
	placeholder: PropTypes.string,
	className: PropTypes.string,
	type: PropTypes.string,
};
export default withErrorBoundary(Textarea, {
	FallbackComponent: ErrorComponent
})
